<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { getAddOnById, updateAddOn } from "../../../api/services/addon.service";
import { getS3SingedUrl } from "../../../api/services/general.service";
import { newExtraObject } from "./extra-controller";
import Multiselect from "vue-multiselect";
import ImageCroperModel from "../../../components/models/image-crop.vue";

export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    extraID: String,
  },
  components: {
    Multiselect,
    "image-cropper-model": ImageCroperModel,
  },
  data() {
    return {
      extraId: null,
      pricingTypes: [
        { name: "Einheits Preisbildung", value: "UNIT" },
        { name: "Gesamte Preisgestaltung", value: "ENTIRE" },
      ],
      vatPercentages: [
        { name: "5%", value: 5 },
        { name: "10%", value: 10 },
        { name: "20%", value: 20 },
      ],
      extraTitle: null,
      extraDescription: null,
      extraTitleImageURL: null,
      extraPricingType: null,
      extraVatPercentage: null,
      extraPrice: null,
      editExtraSuccess: false,
      editExtraFailed: false,
      editExtrasProcessing: false,
      showExtraImageCropModel: false,
      extraImageFileToCrop: null,
      croppedExtraImage: null,
    };
  },
  validations: {
    extraTitle: { required },
    extraDescription: { required },
    extraPricingType: { required },
    extraVatPercentage: { required },
    extraPrice: { required },
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  async mounted() {
    this.extraId = this.extraID;
    await this.getExtra(this.extraId);
  },
  methods: {
    async getExtra(extraId) {
      let getExtraToEdit = await getAddOnById(extraId);
      if (getExtraToEdit) {
        this.extraTitle = getExtraToEdit.title;
        this.extraDescription = getExtraToEdit.description;
        this.extraPrice = getExtraToEdit.price;
        this.extraTitleImageURL = getExtraToEdit.image;

        if (getExtraToEdit.pricingType === "UNIT") {
          this.extraPricingType = this.pricingTypes[0];
        } else if (getExtraToEdit.pricingType === "ENTIRE") {
          this.extraPricingType = this.pricingTypes[1];
        }

        switch (getExtraToEdit.vatPercentage) {
          case 5:
            this.extraVatPercentage = this.vatPercentages[0];
            break;
          case 10:
            this.extraVatPercentage = this.vatPercentages[1];
            break;
          case 20:
            this.extraVatPercentage = this.vatPercentages[2];
            break;
        }
      }
    },
    async clickSaveExtraButton() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.editExtrasProcessing = true;
        let editExtraObject_Pass = new newExtraObject();
        editExtraObject_Pass.extraTitle = this.extraTitle;
        editExtraObject_Pass.extraDescription = this.extraDescription;
        editExtraObject_Pass.extraPricingType = this.extraPricingType.value;
        editExtraObject_Pass.extraPrice = Number(this.extraPrice);
        editExtraObject_Pass.extraVatPercentage = this.extraVatPercentage.value;

        if (this.croppedExtraImage) {
          const extraImageFile = this.$refs.extraImageInput.files[0];
          const croppedExtraImage = this.croppedExtraImage;
          const finalExtraImageToPass = await new Promise(function (resolve) {
            return croppedExtraImage.toBlob(resolve, extraImageFile.type);
          });
          const fileName = extraImageFile.name;
          let getUploadedImageURL = await getS3SingedUrl(fileName);

          let getFileUploadResponse = await axios.put(
            getUploadedImageURL.signedUrl,
            finalExtraImageToPass
          );

          if (getFileUploadResponse) {
            let fileBaseUrl =
              "https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
            editExtraObject_Pass.extraTitleImageURL = fileBaseUrl + fileName;
          }
        }

        if (!this.croppedExtraImage) {
          editExtraObject_Pass.extraTitleImageURL = null;
        }

        let extraEditSuccess = await updateAddOn(
          this.extraId,
          editExtraObject_Pass
        );

        if (extraEditSuccess) {
          this.editExtrasProcessing = false;
          this.editExtraSuccess = true;
          this.$emit("reload");
        } else if (!extraEditSuccess) {
          this.editExtrasProcessing = false;
          this.editExtraFailed = true;
        }
      } else {
        this.editExtrasProcessing = false;
        console.log("Validation Error"); //eslint-disable-line
      }
    },
    extraImageSelected() {
      const imagePreviewCanvers = this.$refs.extraImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );

      const extraImageFile = this.$refs.extraImageInput.files[0];
      this.openCorpExtraImageModel(extraImageFile);
    },
    openCorpExtraImageModel(extraImageFile) {
      this.extraImageFileToCrop = extraImageFile;
      this.showExtraImageCropModel = true;
    },
    setCroppedImageToPreview(croppedImage) {
      const imagePreview = this.$refs.extraImagePreview;
      const imagePreviewCanvers = this.$refs.extraImageCanvas;
      if (imagePreview && imagePreviewCanvers.getContext) {
        const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
        imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
      }
      this.croppedExtraImage = croppedImage;
      this.showExtraImageCropModel = false;
    },
    clickCloseButton() {
      this.$emit("reload");
    },
    clickRemoveExtraImage() {
      this.croppedImage = null;
      this.extraTitleImageURL = null;
    },
  },
};
</script>

<template>
  <!-- Edit Company Model-->
  <b-modal
    v-model="showModal"
    :title="this.$i18n.t('subpackages.createSubpackage.title')"
    centered
    hide-footer
    scrollable
  >
    <div class="row">
      <!-- Edit Sucees and Failed Msg -->
      <div class="col-md-12">
        <b-alert v-model="editExtraSuccess" variant="success" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("extras.editExtra.editSuccessMsg") }}</b-alert
        >
        <b-alert v-model="editExtraFailed" variant="danger" dismissible
          ><i class="bx bx-error-circle mr-2"></i
          >{{ $t("extras.editExtra.editFailedMsg") }}</b-alert
        >
        <b-alert v-model="editExtrasProcessing" variant="info"
          ><i class="bx bx-loader-alt bx-spin mr-2"></i
          >{{ $t("packages.editPackage.editProcessing") }}</b-alert
        >
      </div>
      <!-- Extra Image -->
      <div class="col-md-3 mb-4">
        <div class="avatar-md mr-4">
          <span ref="extraImagePreview" class="extra-image-preview-after-crop">
            <canvas
              id="extraImageCanvas"
              ref="extraImageCanvas"
              height="120"
              width="120"
            ></canvas>
            <span
              v-if="!this.croppedExtraImage"
              class="avatar-title bg-white"
              style="margin-left: -120px"
            >
              <img
                v-if="this.extraTitleImageURL"
                :src="extraTitleImageURL"
                alt
                class="rounded-0"
                height="120"
              />
              <img
                v-else
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/images/ms-sissi-extra-default.png"
                class="rounded-0"
                alt
                height="120"
              />
            </span>
          </span>
        </div>
      </div>
      <div class="col-md-9 mb-4">
        <div class="">
          <input
            id="extraImageInput"
            ref="extraImageInput"
            type="file"
            name="file"
            accept="image/*"
            @change="extraImageSelected()"
            style="width: 0.1px; opacity: 0; z-index: -1"
          />
          <div>
            <label
              for="extraImageInput"
              class="text-info ml-3"
              style="cursor: pointer"
            >
              {{ $t("extras.createExtra.form.uploadNewImage") }}
            </label>
            <!-- <label class="ml-2" v-if="this.extraTitleImageURL"> &#8226; </label> -->
            <!-- <label
              class="text-info ml-2"
              @click="clickRemoveExtraImage()"
              style="cursor: pointer"
              v-if="this.extraTitleImageURL"
            >
              {{ $t("extras.createExtra.form.removeImage") }}
            </label> -->
          </div>
          <div class="ml-3 text-mute">
            <small>
              {{ $t("extras.createExtra.form.imageSupportText") }}
              <br />
              <b> Bildgröße 500px * 500px </b>
            </small>
          </div>
        </div>
      </div>
      <!-- Extra Title -->
      <div class="col-md-12 mt-5">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.titleLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="extraTitle"
                class="badge position-absolute"
                :class="{
                  'badge-light': extraTitle.length !== 50,
                  'badge-danger': extraTitle.length === 50,
                }"
              >
                {{ extraTitle.length }} / 50
              </p>
            </span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="extraTitle"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.titlePlaceholder')
              "
              :maxlength="50"
              :class="{ 'is-invalid': $v.extraTitle.$error }"
            ></b-form-input>
            <div v-if="$v.extraTitle.$error" class="invalid-feedback">
              <span v-if="$v.extraTitle.$error && !$v.extraTitle.required">{{
                $t("extras.createExtra.form.titleRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra Descrtiption -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.descriptionLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="extraDescription"
                class="badge position-absolute"
                :class="{
                  'badge-light': extraDescription.length !== 120,
                  'badge-danger': extraDescription.length === 120,
                }"
              >
                {{ extraDescription.length }} / 120
              </p>
            </span>
          </label>
          <textarea
            v-model="extraDescription"
            class="form-control"
            name="textarea"
            rows="4"
            :maxlength="120"
            :placeholder="
              this.$i18n.t('extras.createExtra.form.descriptionPlaceholder')
            "
            :class="{ 'is-invalid': $v.extraDescription.$error }"
          ></textarea>
          <div v-if="$v.extraDescription.$error" class="invalid-feedback">
            <span
              v-if="$v.extraDescription.$error && !$v.extraDescription.required"
              >{{ $t("extras.createExtra.form.descriptionRequiredMsg") }}</span
            >
          </div>
        </div>
      </div>
      <!-- Extra Pricing Type -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.pricingTypeLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <multiselect
              track-by="name"
              label="name"
              v-model="extraPricingType"
              :options="pricingTypes"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.pricingTypePlaceholder')
              "
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}</template
              >
            </multiselect>
            <div v-if="$v.extraPricingType.$error" class="invalid-feedback">
              <span
                v-if="
                  $v.extraPricingType.$error && !$v.extraPricingType.required
                "
                >{{
                  $t("extras.createExtra.form.pricingTypeRequiredMsg")
                }}</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra vat precentage -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.vatPercentageLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <multiselect
              label="name"
              v-model="extraVatPercentage"
              :options="vatPercentages"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.vatPercentagePlaceholder')
              "
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}</template
              >
            </multiselect>
            <div v-if="$v.extraVatPercentage.$error" class="invalid-feedback">
              <span
                v-if="
                  $v.extraVatPercentage.$error &&
                  !$v.extraVatPercentage.required
                "
                >{{
                  $t("extras.createExtra.form.vatPercentageRequiredMsg")
                }}</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra Price -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.priceLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="extraPrice"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.pricePlaceholder')
              "
              :class="{ 'is-invalid': $v.extraPrice.$error }"
              type="number"
            ></b-form-input>
            <div v-if="$v.extraPrice.$error" class="invalid-feedback">
              <span v-if="$v.extraPrice.$error && !$v.extraPrice.required">{{
                $t("extras.createExtra.form.priceRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Save Button -->
      <div class="col-md-12">
        <div class="">
          <b-button variant="success" @click="clickSaveExtraButton()">
            <i class="bx bxs-save mr-1"></i>
            {{ $t("general.buttons.save") }}</b-button
          >
        </div>
      </div>
    </div>

    <!-- Image Cropper Model -->
    <image-cropper-model
      v-if="this.showExtraImageCropModel === true"
      :visible="showExtraImageCropModel"
      @close="showExtraImageCropModel = false"
      :imageFile="extraImageFileToCrop"
      @apply="setCroppedImageToPreview"
    />
  </b-modal>
</template>

<style scoped>
.extra-image-preview-after-crop {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: none;
  width: 120px;
  height: 120px;
  padding: 0;
  margin: 0;
}
</style>
